module.exports = __webpack_public_path__ + "img/icon-dropdown.67f4a840.svg";